import DisputeDetailsModal from "../pages/orders/dispute_list/components/DisputeDetailsModal";

export const getDisputeButtonDesign = (value, returnedOrder) => {

  if (value?.status === "returned") {
    return (
      <DisputeDetailsModal
        value={value}
        background="#FFF0F0"
        hoverBG="#FFF0F0"
      />
    );
  } 

  if (value.status === "complete" || value?.conversationStatus === 'Reply') {
    return (
      <DisputeDetailsModal
      returnedOrder={returnedOrder}
        value={value}
        background="#E6DCF6"
        hoverBG="rgba(212,255,211, 0.7)"
      />
    );
  }
  if (value.status === "archived") {
    return (
      <DisputeDetailsModal
      returnedOrder={returnedOrder}
        value={value}
        background= "rgba(112, 210, 40, 0.31)"
        hoverBG="rgba(212,255,211, 0.7)"
      />
    );
  }
  if(value.status === "pending" || value?.conversationStatus === 'Waiting'){
    return (
      <DisputeDetailsModal
      returnedOrder={returnedOrder}
        value={value}
        background="#DBE3FC"
        hoverBG="rgba(221,241,255, 0.7)"
      />
    );
  }
  // if (value === "Fulfilled" || value === "In-Transit") {
  //   return (
  //     <DisputeDetailsModal
  //       value={value}
  //       background="#FEFFCF"
  //       hoverBG="rgba(254,255,207, 0.7)"
  //     />
  //   );
  // }
  if (value?.conversationStatus === "Reply") {
    return (
      <DisputeDetailsModal
      returnedOrder={returnedOrder}
            value={value}
            background="#ecf88e"
            hoverBG="rgba(221,241,255, 0.7)"
          />
    );
  }
  // if (value === "Resend") {
  //   return (
  //     <DisputeDetailsModal
  //       value={value}
  //       background="#DDF1FF"
  //       hoverBG="rgba(221,241,255, 0.7)"
  //     />
  //   );
  // }

   
};
